export default {
  zh: {
    watText: 'Waiting',
    cp_level1: 'LV0 初见',
    cp_level2: 'LV1 渐生情愫',
    cp_level3: 'LV2 温柔喜欢',
    cp_level4: 'LV3 深深迷恋',
    cp_level5: 'LV4 甜蜜羁绊',
    cp_level6: 'LV5 灵魂伴侣',
    cp_level7: 'LV6 永恒的爱',
    how_to_become_cp_details1: '将“戒指”赠送给想要成为CP的人，其他人同意后，您即可成为CP',
    switch_cp: '切换CP',
    rules_description1: '1.将“戒指”礼物赠送给想成为CP的人，经对方同意后，即可成为CP',
    rules_description2: '2.成为CP后，即可参与每周CP排行榜，赠送给CP的CP礼物将在情侣广场展示。',
    rules_description3: '3.本次活动最终解释权归Hoby所有，本次活动与苹果无关。',
    cancel: '取消',
    rules: '规则',
    cp_square: 'CP广场',
    reward: '奖励',
    ranking: '排行榜',
    cp_binding_reward_details1: 'Obtaind when the first binding is successful.',
    unbind_toast1: '解绑CP成功',
    unbind_toast2: '解绑CP失败，请稍后重试',
    unbind_pop_up: (name, id) => `确定与${name}(ID:${id})解绑CP吗？`,
    unbind: '解绑',
    cp_gifts_wall_description1: '发送单个CP礼物>=5000金币到你的CP将会显示',
    insetTextL: [
      'I love you forever,forever...',
      'I want to be with you always',
      'You are my lovest one',
      'My love for you is as deep as the sea.',
      'Loving you is closely related to my life.',
      'You, hard to find, hard to forget.',
    ],
    binding_reward: 'CP Binding Reward',
    how_tobecome: 'How To Become CP',
    ranking_title: 'CP 排名',
    cp_squre: 'CP Squre',
    start_your_love: 'Start Your Love',
  },
  ar: {
    watText: 'انتظار',
    unbind: 'إلغاء الربط',
    days: 'أيام',
    cp_square: 'ساحة CP ',
    reward: 'مكافاة',
    ranking: 'قائمة',
    rules: 'القواعد',
    cp_binding_reward_details1: 'يتم الحصول عليه عند نجاح الربط الأول.',
    cp_level1: 'LV0 初见',
    cp_level2: 'LV1 Growing fond',
    cp_level3: 'LV2 Tender like',
    cp_level4: 'LV3 Deep crush',
    cp_level5: 'LV4 Sweet Bond',
    cp_level6: 'LV5 Soul Mate',
    cp_level7: 'LV6 Forever Love',
    how_to_become_cp_details1: `قم بإعطاء هدايا "الخاتم" للشخص الذي تريد أن يصبح CP، وبعد موافقة الآخرين، تصبح CP`,
    switch_cp: 'تبديل CP ',
    rules_description1: `1. قم بإعطاء هدايا "الخاتم" للشخص الذي تريد أن تصبح CP، وبعد موافقة الآخرين تصبح CP`,
    rules_description2:
      '2. بعد أن تصبح CP، يمكنك المشاركة في تصنيفات CP الأسبوعية. سيتم عرض إرسال هدايا CP إلى CP الخاص بك في مربع الأزواج.',
    rules_description3:
      '3. حق التفسير النهائي لهذا الحدث يعود إلى Yayya، وليس لهذا الحدث أي علاقة بشركة Apple.',
    confirm: 'يتأكد',
    cancel: 'إلغاء',
    cp_gifts_wall_description1: 'أرسل هدايا CP واحدة >=5000 قطعة نقدية إلى CP الخاص بك سيتم عرضها',
    unbind_toast1: 'تم إلغاء ربط CP بنجاح',
    unbind_toast2: 'فشل إلغاء ربط CP، يرجى المحاولة مرة أخرى لاحقًا.',
    unbind_pop_up: (name, id) => `هل تريد إلغاء ربط CP مع ${name} (ID:${id})؟`,
    insetTextL: [
      'من الصعب العثور عليك ومن الصعب نسيانك.',
      'حبك جزء لا يتجزأ من حياتي.',
      'حبي لك عميق مثل المحيط.',
      'انت الشخص المفضل لي',
      'أريد أن أكون معك للأبد',
      'أحبك، إلى الأبد ، الابد',
    ],
    binding_reward: 'مكافأة ربط CP',
    how_tobecome: 'كيف تصبح cp',
    ranking_title: 'قائمة',
    cp_squre: 'ساحة CP',
    start_your_love: 'ابدأ حبك',
  },
  en: {
    watText: 'Waiting',
    unbind: 'Unbind',
    days: 'Days',
    cp_square: 'CP square',
    reward: 'Reward',
    ranking: 'Ranking',
    cp_binding_reward_details1: 'Obtaind when the first binding is successful.',
    cancel: 'Cancel',
    confirm: 'Confirm',
    cp_level1: 'LV0 First glance',
    cp_level2: 'LV1 Growing fond',
    cp_level3: 'LV2 Tender like',
    cp_level4: 'LV3 Deep crush',
    cp_level5: 'LV4 Sweet Bond',
    cp_level6: 'LV5 Soul Mate',
    cp_level7: 'LV6 Forever Love',
    how_to_become_cp_details1:
      "Give the gifts of 'Gift Panel CP' to person you want to become cp,after others agree,you become CP",
    switch_cp: 'Switch CP',
    rules: 'Rules',
    rules_description1:
      "1.Give the gifts of 'Ring' to person you want to become cp,after others agree,you become CP",
    rules_description2:
      '2. After becoming a CP, you can participate in the weekly CP rankings. Sending CP gifts to your CP will be displayed in the couple square.',
    rules_description3:
      '3. The final interpretation right of this event belongs to Yayya, and this event has nothing to do with Apple.',
    cp_gifts_wall_description1: 'Send a single CP gifts>=5000 coins to your CP will be displayed',
    unbind_toast1: 'Unbind CP successfully',
    unbind_toast2: 'Unbind CP failed, please try again later.',
    unbind_pop_up: (name, id) => `Confirm to unbind the CP with ${name} (ID:${id})?`,
    insetTextL: [
      'I love you forever,forever...',
      'I want to be with you always',
      'You are my lovest one',
      'My love for you is as deep as the sea.',
      'Loving you is closely related to my life.',
      'You, hard to find, hard to forget.',
    ],
    binding_reward: 'CP Binding Reward',
    how_tobecome: 'How To Become CP',
    ranking_title: 'Ranking',
    cp_squre: 'CP Squre',
    start_your_love: 'Start Your Love',
  },
  tr: {
    watText: 'Bekliyor',
    unbind: 'Bağlantıyı Kaldır',
    days: 'gün',
    cp_square: 'CP Karesi',
    reward: 'Ödül',
    ranking: 'Sıralama',
    rules: 'Kural',
    cp_binding_reward_details1: 'İlk Cp başarılı olduğunda elde edin.',
    cancel: 'İptal',
    confirm: 'Onayla',
    cp_level1: 'LV0 İlk Bakış',
    cp_level2: 'LV2 Hassas Aşk',
    cp_level3: 'LV3 Derin Aşk',
    cp_level4: 'LV4 Tatlı Aşk',
    cp_level5: 'SV5 Ruh Eşİ',
    cp_level6: 'ŞV6 Sonsuz Aşk',
    how_to_become_cp_details1:
      "CP olmasını istediğiniz kişiye 'Yüzük' hediyesini Gönderin, Gönderdiğiniz kişi kabul ettikten sonra CP olursunuz",
    switch_cp: 'Cp Değiştir',
    rules_description1:
      "1. CP olmasını istediğiniz kişiye 'Yüzük' hediyesini Gönderin, Gönderdiğiniz kişi kabul ettikten sonra CP olursunuz",
    rules_description2:
      "2. CP olduktan sonra haftalık CP sıralamalarına katılabilirsiniz. CP'nize CP hediyeleri göndermek çift meydanında görüntülenecektir.",
    rules_description3:
      "3. Bu etkinliğin son yorumlama hakkı Yayya'ye ait olup, bu etkinliğin Apple ile hiçbir ilgisi yoktur.",
    cp_gifts_wall_description1: "Tek bir CP hediyesi gönder> =5000 Altın CP'nize görüntülenecektir",
    unbind_toast1: "CP'nin bağlantısını başarıyla kaldırdınız",
    unbind_toast2: "CP'nin bağlantısı kaldırılamadı. Lütfen daha sonra tekrar deneyin.",
    unbind_pop_up: (name, id) =>
      `CP'nin ${name} (ID:${id}) ile bağlantısını kesmeyi onaylıyor musunuz?`,
    insetTextL: [
      'Seni sonsuza kadar seviyorum, sonsuza dek...',
      'Her zaman seninle olmak istiyorum',
      'Sen benim en sevdiğimsin',
      'Sana olan sevgim deniz kadar derin.',
      'Seni sevmek benim hayatımda en önemli şey',
      'Seni bulmak zor, unutmak zor.',
    ],
    binding_reward: 'CP Bağlantı Ödülü',
    how_tobecome: 'Nasıl CP olunur?',
    ranking_title: 'Sıralama',
    cp_squre: 'CP Karesi',
    start_your_love: 'Aşkına Başla',
  },
  pt: {
    watText: 'Aguardando',
    unbind: 'Desvincular',
    days: 'Dias',
    cp_square: 'Praça CP',
    reward: 'Recompensa',
    ranking: 'Classificação',
    cp_binding_reward_details1: 'Obtido quando o primeiro vínculo for bem-sucedido.',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    cp_level1: 'LV0 Primeira impressão',
    cp_level2: 'LV1 Crescendo carinho',
    cp_level3: 'LV2 Gosto suave',
    cp_level4: 'LV3 Paixão profunda',
    cp_level5: 'LV4 Laço doce',
    cp_level6: 'LV5 Alma gêmea',
    cp_level7: 'LV6 Amor eterno',
    how_to_become_cp_details1:
      "Dê o presente de 'Anel' para a pessoa que você quer se tornar CP, após a outra pessoa concordar, você se torna CP",
    switch_cp: 'Trocar CP',
    rules: 'Regras',
    rules_description1:
      "1. Dê o presente de 'Anel' para a pessoa que você quer se tornar CP, após a outra pessoa concordar, você se torna CP",
    rules_description2:
      '2. Após se tornar CP, você pode participar das classificações semanais de CP. Enviar presentes CP para o seu CP será exibido na praça dos casais.',
    rules_description3:
      '3. O direito de interpretação final deste evento pertence à Yayya, e este evento não tem relação com a Apple.',
    cp_gifts_wall_description1:
      'Envie um presente CP único >= 5000 moedas para seu CP, que será exibido',
    unbind_toast1: 'Desvinculação do CP bem-sucedida',
    unbind_toast2: 'Falha ao desvincular o CP, por favor, tente novamente mais tarde.',
    unbind_pop_up: (name, id) => `Confirmar desvinculação do CP com ${name} (ID:${id})?`,
    insetTextL: [
      'Eu te amo para sempre, para sempre...',
      'Eu quero estar com você sempre',
      'Você é meu amado',
      'Meu amor por você é tão profundo quanto o mar.',
      'Amar você está intimamente relacionado à minha vida.',
      'Você, difícil de encontrar, difícil de esquecer.',
    ],
    binding_reward: 'Recompensa de vinculação CP',
    how_tobecome: 'Como Se Tornar CP',
    ranking_title: 'Classificação',
    cp_squre: 'Praça CP',
    start_your_love: 'Comece Seu Amor',
  },
  id: {
    watText: 'Menunggu',
    unbind: 'Batal ikatan',
    days: 'Hari',
    cp_square: 'Pusat CP',
    reward: 'Hadiah',
    ranking: 'Peringkat',
    cp_binding_reward_details1: 'Didapatkan saat ikatan pertama berhasil.',
    cancel: 'Batal',
    confirm: 'Konfirmasi',
    cp_level1: 'LV0 Pandangan pertama',
    cp_level2: 'LV1 Tumbuh suka',
    cp_level3: 'LV2 Suka lembut',
    cp_level4: 'LV3 Jatuh cinta mendalam',
    cp_level5: 'LV4 Ikatan manis',
    cp_level6: 'LV5 Pasangan jiwa',
    cp_level7: 'LV6 Cinta abadi',
    how_to_become_cp_details1:
      "Beri hadiah 'Cincin' kepada orang yang Anda ingin jadi CP, setelah disetujui orang lain, Anda menjadi CP",
    switch_cp: 'Ganti CP',
    rules: 'Aturan',
    rules_description1:
      "1. Beri hadiah 'Cincin' kepada orang yang Anda ingin jadi CP, setelah disetujui orang lain, Anda menjadi CP",
    rules_description2:
      '2. Setelah menjadi CP, Anda bisa berpartisipasi dalam peringkat CP mingguan. Kirim hadiah CP ke CP Anda akan ditampilkan di pusat pasangan.',
    rules_description3:
      '3. Hak interpretasi akhir dari acara ini milik Yayya, dan acara ini tidak ada hubungannya dengan Apple.',
    cp_gifts_wall_description1: 'Kirim hadiah CP tunggal>=5000 koin ke CP Anda akan ditampilkan',
    unbind_toast1: 'Batal ikatan CP berhasil',
    unbind_toast2: 'Batal ikatan CP gagal, coba lagi nanti.',
    unbind_pop_up: (name, id) =>
      `Konfirmasi untuk membatalkan ikatan CP dengan ${name} (ID:${id})?`,
    insetTextL: [
      'Aku mencintaimu selamanya, selamanya...',
      'Aku ingin selalu bersamamu',
      'Kaulah cintaku',
      'Cintaku padamu sedalam lautan.',
      'Mencintaimu sangat erat kaitannya dengan hidupku.',
      'Kau, sulit ditemukan, sulit dilupakan.',
    ],
    binding_reward: 'Hadiah Pengikatan CP',
    how_tobecome: 'cara menjadi CP',
    ranking_title: 'Peringkat',
    cp_squre: 'Lapangan CP',
    start_your_love: 'Mulai Cintamu',
  },
  uz: {
    watText: 'Kutish',
    days: 'Kunlar',
    cancel: 'Bekor qilish',
    cp_level1: "LV0 Birinchi ko'rish",
    cp_level2: "LV1 O'sib borayotgan muhabbat",
    cp_level3: 'LV2 Yumshoq sevgi',
    cp_level4: 'LV3 Chuqur sevgi',
    cp_level5: 'LV4 Shirin aloqalar',
    cp_level6: 'LV5 Ruhiy hamkor',
    cp_level7: 'LV6 Abadiy sevgi',
    unbind_pop_up: (name, id) => `Cp qopqog'ini  ${name} (ID:${id}) bilan tasdiqlaysizmi?`,
    insetTextL: [
      'Sevaman seni abadiy,abad...',
      "Doim sen bilan birga bo'lishni istayman",
      'Sen mening sevganimsan',
      "Senga bo'lgan muhabbatim dengizdek chuqur.",
      "Seni sevish hayotim bilan chambarchas bog'liq.",
      'Seni topish qiyin, unutish qiyin.',
    ],
    cp_binding_reward: 'CP majburiy mukofoti',
    cp_binding_reward_details1: "Muvaffaqiyatli birinchi bog'lash bilan olinadi.",
    how_to_become_cp: "Qanday qilib CP bo'lish mumkin",
    how_to_become_cp_details1: "Boshqa tomon rozi bo'lgandan so'ng, siz CP bo'lishingiz mumkin.",
    ranking: 'Reyting',
    cp_square: 'CP maydoni',
    reward: 'Mukofot',
    switch_cp: 'CP-ni almashtirish',
    rules: 'Qoidalar',
    rules_description1: "1.Boshqa tomon rozi bo'lgandan so'ng, siz CP bo'lishingiz mumkin.",
    rules_description2:
      "2.CP bo'lish orqali siz haftalik CP reytingida qatnashishingiz mumkin. Siz CP ga bergan CP sovg'asi CP maydonida ko'rsatiladi.",
    rules_description3:
      "3. Ushbu tadbirni yakuniy talqin qilish huquqi Yayya-ga tegishli va bu tadbir Apple bilan hech qanday aloqasi yo'q.",
    cp_gifts_wall: "Sovg'a devori CP",
    cp_gifts_wall_description1:
      "Agar siz CP-ga bitta CP >= 5000 tanga sovg'a yuborsangiz, siz bu erda ko'rsatilasiz",
    start_your_love: 'Sevgingizni boshlang',
    select_cp: 'CP-ni tanlang',
    confirm: 'Tasdiqlash',
    unbind: 'Yechish',
    unbind_toast1: 'CP-ni muvaffaqiyatli echib oling',
    unbind_toast2: "CP langarini echib bo'lmadi. Keyinroq qayta urinib ko'ring.",
    cp_rejection_notice: "CP rad etish to'g'risida bildirishnoma",
    cp_rejection_notice_content: "Kechirasiz, {0}(ID:{1}) sizning CP bo'lishdan bosh tortdi.",
    cp_cancellation_notice: 'CP deklanşör xabarnomasi',
    cp_cancellation_notice_content: "{0}(ID:{1}) CP-ni siz bilan bog'lamagan",
    girst_binding_cp_reward_notice: 'Birinchi marta CP majburiy mukofoti haqida xabar',
    girst_binding_cp_reward_notice_content:
      "Cp-ni {0} (ID: {1}) ga bog'lash va {2} olish bilan tabriklaymiz. Rasmiy Yayya vakillari bir-biringizni abadiy sevishingizni xohlashadi.",
    cp_weekly_ranking_reward_notice: 'Haftalik CP reytingi uchun mukofot bildirishnomasi',
    cp_weekly_ranking_reward_notice_content:
      "Sizni va {0} (ID: {1}) o'tgan hafta cp TOP {2} va {3} g'olibligi bilan tabriklaymiz. Yayya rasmiylari bir-biringizni abadiy sevishingizni xohlashadi.",
    wave_name_days: "[To'lqin] {0}*{1} kunlar",
    Entry_name_days: '[Kirish] {0}*{1} kunlar',
    cp_gift_walls_description1: 'Men seni abadiy, abadiy sevaman...',
    cp_gift_walls_description2: "Men har doim siz bilan bo'lishni xohlayman",
    cp_gift_walls_description3: 'Siz mening eng sevimliimsiz',
    cp_gift_walls_description4: "Sizga bo'lgan muhabbatim dengiz kabi chuqurdir",
    cp_gift_walls_description5: "Sizga bo'lgan muhabbat mening hayotim bilan chambarchas bog'liq",
    cp_gift_walls_description6: 'Sizni topish qiyin, unutish qiyin',
    binding_reward: 'CP majburiy mukofoti',
    how_tobecome: "Qanday qilib CP bo'lish mumkin",
    ranking_title: 'Reyting',
    cp_squre: 'CP maydoni',
  },
  ru: {
    watText: 'Ожидание',
    days: 'Дни',
    cancel: 'Отмена',
    cp_level1: 'LV0 Первый взгляд',
    cp_level2: 'LV1 Растущая привязанность',
    cp_level3: 'LV2 Нежная привязанность',
    cp_level4: 'LV3 Глубокая влюбленность',
    cp_level5: 'LV4 Сладкая связь',
    cp_level6: 'LV5 Родственная душа',
    cp_level7: 'LV6 Вечная любовь',
    unbind_pop_up: (name, id) => `Подтвердите отвязку CP с ${name} (ID:${id})?`,
    insetTextL: [
      'Я буду любить тебя всегда, всегда...',
      'Я хочу быть с тобой всегда',
      'Ты моя самая любимая',
      'Моя любовь к тебе так же глубокая, как море.',
      'Любить тебя связано с моей жизнью.',
      'Ты, трудно найти, трудно забыть.',
    ],
    cp_binding_reward: 'Награда за привязку CP',
    cp_binding_reward_details1: 'Получается при успешной первой привязке.',
    how_to_become_cp: 'Как стать CP',
    how_to_become_cp_details1:
      'Подарите  “кольцо” человеку, с которым вы хотите вступить в СР. После того, как другая сторона согласится, вы можете стать СР.',
    ranking: 'Рейтинг',
    cp_square: 'Площадь CP',
    reward: 'Награда',
    switch_cp: 'Переключить CP',
    rules: 'Правила',
    rules_description1:
      '1.Подарите “кольцо” человеку, с которым вы хотите вступить в СР. После того, как другая сторона согласится, вы можете стать СР.',
    rules_description2:
      '2.Став CP, вы сможете участвовать в еженедельном рейтинге CP. Подарок CP, который вы подарили CP, будет отображен в площади CP.',
    rules_description3:
      '3. Право на окончательную интерпретацию данного мероприятия принадлежит Yayya, и это мероприятие не имеет никакого отношения к Apple.',
    cp_gifts_wall: 'Стена подарков CP',
    cp_gifts_wall_description1:
      'Если отправьте один подарок CP >= 5000 монет на ваш CP, вы будете показаны здесь',
    start_your_love: 'Начни свою любовь',
    select_cp: 'Выберите CP',
    confirm: 'Подтверждать',
    unbind: 'Отвязать',
    unbind_toast1: 'Отвязать CP успешно',
    unbind_toast2: 'Не удалось отвязать привязку CP. Повторите попытку позже.',
    cp_rejection_notice: 'Уведомление об отказе в CP',
    cp_rejection_notice_content: 'Извините,{0}(ID:{1}) отказался стать вашим CP.',
    cp_cancellation_notice: 'Уведомление об отвязке CP',
    cp_cancellation_notice_content: '{0}(ID:{1}) отвязал CP с вами',
    girst_binding_cp_reward_notice: 'Уведомление о награде за привязку CP в первый раз',
    girst_binding_cp_reward_notice_content:
      'Поздравляем с привязкой CP к {0} (ID: {1}) и с получением {2}. Официальный представители Yayya желают, чтобы вы любили друг друга вечно.',
    cp_weekly_ranking_reward_notice: 'Уведомление о вознаграждении за еженедельный рейтинг CP',
    cp_weekly_ranking_reward_notice_content:
      'Поздравляем вас и {0} (ID: {1}) с победой в рейтинге CP TOP {2} и {3} на прошлой неделе. Официальные представители Yayya желают, чтобы вы любили друг друга вечно.',
    wave_name_days: '[Волна] {0}*{1} дней',
    Entry_name_days: '[Вход] {0}*{1} дней',
    cp_gift_walls_description1: 'Я люблю тебя навсегда, навсегда...',
    cp_gift_walls_description2: 'Я хочу быть с тобой всегда',
    cp_gift_walls_description3: 'Ты мой самый любимый',
    cp_gift_walls_description4: 'Моя любовь к тебе глубока, как море',
    cp_gift_walls_description5: 'Любовь к тебе тесно связана с моей жизнью',
    cp_gift_walls_description6: 'Тебя трудно найти, трудно забыть',
    binding_reward: 'Награда за привязку CP',
    how_tobecome: 'Как стать CP',
    ranking_title: 'Рейтинг',
    cp_squre: 'Площадь CP',
  },
  fa: {
    watText: 'در حال انتظار',
    unbind: 'لغو اتصال',
    days: 'روزها',
    cp_square: 'میدان CP',
    reward: 'جایزه',
    ranking: 'رتبه‌بندی',
    cp_binding_reward_details1: 'هنگامی که اولین اتصال موفقیت‌آمیز است، دریافت می‌شود.',
    cancel: 'لغو',
    confirm: 'تایید',
    cp_level1: 'LV0 اولین نگاه',
    cp_level2: 'LV1 علاقه رو به رشد',
    cp_level3: 'LV2 علاقه نرم',
    cp_level4: 'LV3 عشق عمیق',
    cp_level5: 'LV4 پیوند شیرین',
    cp_level6: 'LV5 هم‌روح',
    cp_level7: 'LV6 عشق ابدی',
    how_to_become_cp_details1:
      "'حلقه' را به کسی که می‌خواهید CP شوید، بدهید، پس از موافقت دیگران، شما CP خواهید شد",
    switch_cp: 'تغییر CP',
    rules: 'قوانین',
    rules_description1:
      "1. 'حلقه' را به کسی که می‌خواهید CP شوید، بدهید، پس از موافقت دیگران، شما CP خواهید شد",
    rules_description2:
      '2. پس از تبدیل شدن به CP، می‌توانید در رتبه‌بندی هفتگی CP شرکت کنید. ارسال هدایای CP به CP شما در میدان زوج نمایش داده خواهد شد.',
    rules_description3:
      '3. حق تفسیر نهایی این رویداد متعلق به Yayya است و این رویداد هیچ ارتباطی با Apple ندارد.',
    cp_gifts_wall_description1: 'یک هدیه CP>=5000 سکه به CP خود ارسال کنید، تا نمایش داده شود',
    unbind_toast1: 'CP با موفقیت لغو شد',
    unbind_toast2: 'لغو CP ناموفق بود، لطفا بعدا دوباره امتحان کنید.',
    unbind_pop_up: (name, id) => `آیا تایید می‌کنید که CP با ${name} (ID:${id}) را لغو کنید؟`,
    insetTextL: [
      'من همیشه تو را دوست دارم، همیشه...',
      'می‌خواهم همیشه با تو باشم',
      'تو عزیزترین فرد منی',
      'عشق من به تو به اندازه دریا عمیق است.',
      'دوست داشتن تو به زندگی من مرتبط است.',
      'تو، سخت پیدا می‌کنی، سخت فراموش می‌کنی.',
    ],
    binding_reward: 'پاداش اتصال CP',
    how_tobecome: 'چگونه سی پی شویم',
    ranking_title: 'رتبه‌بندی',
    cp_squre: 'میدان سی پی',
    start_your_love: 'عشقت را آغاز کن',
  },
  ur: {
    watText: 'انتظار',
    unbind: 'کھولیں',
    days: 'دن',
    cp_square: 'CP اسکوائر',
    reward: 'انعام',
    ranking: 'درجہ بندی',
    cp_binding_reward_details1: 'پہلی بار بائنڈنگ کامیاب ہونے پر حاصل کریں۔',
    cancel: 'منسوخ کریں',
    confirm: 'تصدیق کریں',
    cp_level1: 'LV0 پہلی نظر',
    cp_level2: 'LV1 دلچسپی',
    cp_level3: 'LV2 نرم جذبات',
    cp_level4: 'LV3 گہری محبت',
    cp_level5: 'LV4 میٹھا رشتہ',
    cp_level6: 'LV5 روحانی ساتھی',
    cp_level7: 'LV6 ہمیشہ کی محبت',
    how_to_become_cp_details1:
      'جس شخص سے آپ CP بننا چاہتے ہیں، اسے "رنگ" گفٹ دیں، دوسرے کی رضامندی کے بعد آپ CP بن جائیں گے',
    switch_cp: 'CP تبدیل کریں',
    rules: 'قواعد',
    rules_description1:
      '1. جس شخص سے آپ CP بننا چاہتے ہیں، اسے "رنگ" گفٹ دیں، دوسرے کی رضامندی کے بعد آپ CP بن جائیں گے',
    rules_description2:
      '2. CP بننے کے بعد، آپ ہفتہ وار CP درجہ بندی میں حصہ لے سکتے ہیں۔ اپنے CP کو CP گفٹس بھیجنے سے جوڑے کے اسکوائر میں دکھایا جائے گا۔',
    rules_description3:
      '3. اس ایونٹ کی حتمی تشریح کا حق Yayya کے پاس ہے، اور اس ایونٹ کا ایپل سے کوئی تعلق نہیں ہے۔',
    cp_gifts_wall_description1:
      'اپنے CP کو 5000 سکے یا اس سے زیادہ کی CP گفٹ بھیجیں تو دکھایا جائے گا',
    unbind_toast1: 'CP کامیابی سے کھولا گیا',
    unbind_toast2: 'CP کھولنے میں ناکامی، براہ کرم بعد میں کوشش کریں۔',
    unbind_pop_up: (name, id) => `کیا آپ واقعی ${name} (ID:${id}) کے ساتھ CP کھولنا چاہتے ہیں؟`,
    insetTextL: [
      'میں تم سے ہمیشہ محبت کروں گا، ہمیشہ...',
      'میں ہمیشہ تمہارے ساتھ رہنا چاہتا ہوں',
      'تم میری سب سے پیاری ہو',
      'تمہارے لیے میری محبت سمندر جیسی گہری ہے۔',
      'تم سے محبت میری زندگی سے گہرا تعلق رکھتی ہے۔',
      'تم، ڈھونڈنا مشکل، بھلانا مشکل۔',
    ],
    binding_reward: 'CP بائنڈنگ انعام',
    how_tobecome: 'CP کیسے بنیں',
    ranking_title: 'درجہ بندی',
    cp_squre: 'CP اسکوائر',
    start_your_love: 'اپنی محبت کا آغاز کریں',
  },
}



// WEBPACK FOOTER //
// src/pages/activity/couplesNew/lang.js